import * as React from 'react';
import { Message, MessageCategory } from '../../models';
import { Button, TextArea, Modal } from 'semantic-ui-react';
import { Tags } from '../Tags/Tags';
import { MESSAGE_MAX_CHARS } from '../../constants';


export interface MessageItemEditViewProps {
  message: Message;
  messageCategories: MessageCategory[];
  hasSearchQuery: boolean;
  editMessageRequest(message: Message): void;
  id: number;
  cancelEditMessage(): void;
}

export interface MessageItemEditViewState {
  message: Message;
  isEditing: boolean;
  editedMessage: string;
  showDelete: boolean;
  hasSearchQuery: boolean;
}

export class MessageItemEditView
  extends React.Component<MessageItemEditViewProps, MessageItemEditViewState> {
  messageCell: HTMLTableCellElement;

  constructor(props: MessageItemEditViewProps, state: MessageItemEditViewState) {
    super(props, state);
    this.state = {
      message: { ...props.message },
      isEditing: false,
      editedMessage: this.sliceOriginalMessageIfNeeded(),
      showDelete: false,
      hasSearchQuery: props.hasSearchQuery,
    };
  }

  componentWillReceiveProps(nextProps: MessageItemEditViewProps) {
    this.setState({ hasSearchQuery: nextProps.hasSearchQuery });
  }

  sliceOriginalMessageIfNeeded = (): string => {
    const { message } = this.props;
    const text = message.text;
    return text.length <= MESSAGE_MAX_CHARS ? text : text.slice(0, MESSAGE_MAX_CHARS);
  }

  messageEdited = (event: React.SyntheticEvent<HTMLTextAreaElement>) => {
    const message = event.currentTarget.value;
    if (!message || message.length <= MESSAGE_MAX_CHARS) {
      this.setState({ editedMessage: message });
    }
  }

  cancelEditClicked = () => {
    this.props.cancelEditMessage();
    this.setState({
      isEditing: false,
      editedMessage: this.state.message.text,
    });
  }

  saveMessageClicked = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    const newMessage = this.state.message;
    newMessage.text = this.state.editedMessage;
    this.props.editMessageRequest(this.state.message);
    this.setState({ isEditing: false, message: newMessage });
  }


  editMessage = () => {
    this.setState({ isEditing: true });
  }

  getMessageElementId = () => `canned-message-${this.props.message.id}`;

  onTagSelectionChanged = (tags: number[]) => {
    const categories = tags.filter(t => t > 0).map((t: number) => {
      const existing = this.state.message.categories.find(c => c.id === t);
      if (existing) {
        return existing;
      } else {
        return {
          id: t,
          displayOrder: (this.props.messageCategories.find(mc => mc.id === t)!.messages.length + 1),
        };
      }

    });

    const msg = { ...this.state.message, categories };
    this.setState({ message: msg });
  }

  setupRef = (ta: any) => {
    if (ta) {
      ta.focus();
    }
  }
  getMessageEditingView = (message: Message) => {
    const { id, messageCategories } = this.props;
    const { editedMessage } = this.state;

    const editedMessageLength = (editedMessage && editedMessage.length) || 0;
    return (
      <div>

        <Modal size="tiny" open={true}>
          <Modal.Header>
            Edit Message
            </Modal.Header>
          <Modal.Content>
            <TextArea
              className="editMessageTextarea"
              onChange={this.messageEdited}
              placeholder="Type your message..."
              rows={2}
              defaultValue={message.text}
              autoHeight={true}
              value={editedMessage}
              id={`editInput_${id}`}
              ref={this.setupRef}
            />
            <span 
              className="addMessageSectionTotalChars" 
              style={{ color: editedMessageLength === MESSAGE_MAX_CHARS ? 'orange' : 'unset' }}
            >
            {editedMessageLength}/{MESSAGE_MAX_CHARS}
            </span>
            <div className="categoryDropdown">
              <Tags
                messageCategories={messageCategories}
                selectedTags={message.categories.map(c => (c.id || 0))}
                onTagSelectionChanged={this.onTagSelectionChanged}
              />

            </div>
          </Modal.Content>

          <Modal.Actions className="editActions">
            <Button
              className="editMessageCancel"
              onClick={this.cancelEditClicked}
              circular={true}
              basic={true}
              color="blue"
            >
              Nevermind
            </Button>
            <Button
              primary={true}
              className="editMessageSave"
              onClick={this.saveMessageClicked}
              disabled={this.state.message.text === ''}
              circular={true}
            >
              Save
            </Button>
          </Modal.Actions>
        </Modal>


      </div>
    );
  }
  showDeleteButton = () => {
    this.setState({
      showDelete: true,
    });
  }
  getMessageView = (message: Message) => {
    return (
      <div>
        {
          this.getMessageEditingView(message)
        }
      </div>
    );
  }

  render() {
    const { message } = this.props;
    return (
      this.getMessageView(message)
    );
  }
}






// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MessageItem/MessageItemEditView.tsx